export default __webpack_public_path__ + "static/media/battlecry.3cba1cc8.png";